import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { contactUsService, ContactUsPayload } from "api/services/contact";

export const useContactUs = () => {
  return useMutation({
    mutationFn: (payload: ContactUsPayload) => contactUsService(payload),
    onSuccess: (response) => {
      toast.success(response.data.message ?? "Thank you for contacting us. We will reach out to you soon!");
    },
    onError: (err: any) => {
      const errorMessage =
        err?.response?.data?.message ||
        "Failed to send message. Please try again.";
      toast.error(errorMessage);
    },
  });
};
